import React, { useState, useContext } from "react";
import { Button } from "@activehub/common-components-spa-resource";
import { emailCode } from "../../../network/ApiService";
import { AppContext } from "../../../App";

import "./AccessCodesActionModal.scss";
const EmailAccessCodes = ({ setLoading, currentRequestId }) => {
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [emailId, setEmailId] = useState("");
    const [hasBeenValidated, setHasBeenValidated] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [isTyping, setIsTyping] = useState(false);

    const {
        setToast,
        translateHTML: tHTML
    } = useContext(AppContext);
    
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;

    const toastMessage = ({ title,msg, status }) => {
    setToast({
        title: tHTML(title,{unsafe: true}),
        msg: tHTML(msg, { unsafe: true}),
        styleClass: 'DownloadAccessCodeToast',
        status: status,
        delay: 8000,
        autoHide: true,
        toastImg: `${process.env.PUBLIC_URL}/images/${status==="success" ? "success-green-outline.svg" : "error-red-outline.svg"}`,
        show: true,
        });
    };

    const handleEmailInput = (e) => {
        setEmailId(e.target.value);
        setIsTyping(true);
        setHasBeenValidated(false);
        setEmailError('');
        setIsEmailValid(false);
    };

    const validateEmail = () => {        
        setIsTyping(false);
        setHasBeenValidated(true);
        if(!emailId) {
            setIsEmailValid(false);
            setEmailError('');
            return false;
        } 

        else if (emailId.includes('..')) {
            setIsEmailValid(false);
            setEmailError('Please enter a valid email address');
            return false;
        }

        else if (emailId.startsWith('.') || emailId.endsWith('.')) {
            setIsEmailValid(false);
            setEmailError('Please enter a valid email address');
            return false;
        }

        else if (emailId.includes('.@')) {
            setIsEmailValid(false);
            setEmailError('Please enter a valid email address');
            return false;
        }

        else if (emailId.includes('@.')) {
            setEmailError('Please enter a valid email address');
            setIsEmailValid(false);
            return false;
        }

        else if (emailRegex.test(emailId)) {
            setIsEmailValid(true);
            setEmailError('');
            return true;
        }

        else {
            setIsEmailValid(false);
            setEmailError('Please enter a valid email address');
            return false;
        }
    };

    const handleEmail = () => {
        if (!emailId) {
            setEmailError('Email is required');
            setIsEmailValid(false);
            setHasBeenValidated(true);
            setIsTyping(false);
            return false;
        }
        if (validateEmail(emailId)) {
            let emailRecipients = [emailId];
            const payload = {
                "requestId": currentRequestId,
                "emailRecipients": emailRecipients
            };
            setLoading(true);

            const subscription = emailCode(payload).subscribe(
                (response) => {
                    setLoading(false);
                    toastMessage({ 
                        title:'Successfully emailed', 
                        msg: 'Access codes have been successfully emailed', 
                        status: 'success' 
                    });
                },
                (error) => {
                    setLoading(false);
                    toastMessage({ 
                        title:'Not emailed successfully',
                        msg: 'Access codes have not been emailed. Please try again.', 
                        status: 'error' 
                    });
                }
            );

            return () => subscription.unsubscribe();
        }
    };

    return (
        <>
            <div className="email-modal-content">
                <span className="heading">Email selected codes</span>
                <span className="body">
                    Email selected access codes. Please note all codes will be valid for 3 years from customer redemption date.
                </span>
                <div className="email-input-section">
                    <span className='email-address-label'>Enter email address to send the codes to</span>
                    {hasBeenValidated && !isEmailValid && emailError && !isTyping && (
                        <div className="error-email">
                            <img src={`${process.env.PUBLIC_URL}/images/error-new.svg`} alt="close" height="16px" width="16px" />
                            <span>{emailError}</span>
                        </div>
                    )}
                    <div className="email-input-field">
                        <input
                            placeholder='Enter email address'
                            className={`email-address-input ${emailId && hasBeenValidated ? isEmailValid ? 'valid-email' : 'invalid-email' : ''}`}
                            value={emailId}
                            onChange={(e) => handleEmailInput(e)}
                            onBlur={() => validateEmail()}
                        />
                        {emailId && (
                            <button 
                                className="clearEmail" 
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    setEmailId("");
                                    setIsEmailValid(false);
                                    setHasBeenValidated(false);
                                    setEmailError('');
                                    setIsTyping(false);
                                }}
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" height="12px" width="12px" />
                            </button>
                        )}
                    </div>
                </div>
                <Button
                    className={`email-access-codes-btn ${isEmailValid && !isTyping && emailId ? 'email-valid' : 'email-invalid'}`}
                    disabled={!isEmailValid || isTyping || !emailId}
                    onClick={handleEmail}>
                    <span>Email codes</span>
                </Button>
            </div>
        </>
    )
}
export default EmailAccessCodes;
